import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/map': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 32c8.5 0 16 6.8 16 16v346.3c0 12-9 25.3-20.1 29.7l-151.8 52.8c-5.3 1.7-14.2 3.1-19.8 3.1-5.7 0-14.8-1.5-20.3-3.3l-172-60.7-170.1 62.8c-2 0.8-4 1.2-6 1.2-8.5 0-16-6.8-16-16v-346.3c0-12 9-25.3 20.1-29.7l151.8-52.8c6.4-2.1 13.1-3.1 19.8-3.1 5.7 0 14.8 1.5 20.2 3.3l172 60.7h0l170.1-62.8c2-0.8 4-1.2 6-1.2zM224 90.4v286l128 45.2v-286zM48 418l127.4-47.1 0.6-0.2v-286.2l-128 44.5v289zM528 382.9v-289l-127.4 47.1-0.6 0.2v286.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/map.js
// module id = 1795
// module chunks = 0